import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Checkbox extends React.Component {

  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    enabled: PropTypes.bool
  }

  render () {
    let disabledState=false;
    if(this.props.enabled === false)
      disabledState=true;
    return (
      <div className={styles.container}>
        <label>
          <input disabled={disabledState} onClick={ (e) => this.handleClick(e) } checked={this.props.value} onChange={() => this.props.onChange(!this.props.value)} type='checkbox' />
          <span className={styles.label}>{this.props.label}</span>
        </label>
      </div>
    )
  }

  handleClick(e){
    e.stopPropagation(); 
  }

  

}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Menu/Checkbox/index.js